module.exports = __webpack_public_path__ + "static/auto-sync-1bd0ef606eaff887442176ae008ca160.png";